module.exports = __webpack_public_path__ + "static/img/ft.a9fb038.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/ft.png
// module id = y8fx
// module chunks = 1